'use client';
/* Built In Imports */
import { useEffect, useState } from 'react';

/* External Imports */
import { Box, Image, Flex, Text, Icon } from '@chakra-ui/react';
import { nanoid } from 'nanoid';
import Slider from 'react-slick';

/* Internal Imports */
/* Components */
// import { consoleLog } from '@components/Utility/Shared/SharedService';
import config from '@config';

/* Services */
/* Styles */
// import 'react-image-lightbox/style.css';
import SliderDots from '@app-ila/components/Icons/SliderDots';

import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';
import { modifyDatoImgUrlToStatic } from './utils';

/**
 * Render Slider Image Gallery Component
 *
 * @param sectionContent.sectionContent
 * @param {object} sectionContent
 * @returns {ReactElement} Slider Image Gallery Component
 */

const KarmaSliderComponent = ({ sectionContent, width, height, nextArrRightPos, prevArrRightPos }) => {
    const [currentSlide, setCurrentSlide] = useState(0);
    const images = sectionContent?.images?.map(image => image.url);
    let [isEndReached, setIsEndReached] = useState(false)

    let [unqSliderId, setUnqSliderId] = useState(new Date().getTime())
    let [sliderKey, setSliderkey] = useState(0)

    useEffect(() => {
        const handleResize = () => {
            setSliderkey(prev => prev + 1)
        }
        window.addEventListener("resize", handleResize)
        window.removeEventListener("resize", handleResize)
    }, [])

    useEffect(() => {
        if (currentSlide + 1 === sectionContent?.images?.length) {
            setIsEndReached(true)
        }
        else {
            setIsEndReached(false)
        }
        // if (currentSlide === 0) {
        //     setIsEndReached(false)
        // }
    }, [currentSlide])    


    const NextArrow = ({ onClick }) => {
        if (!isEndReached) {
        return (
            <Box
                as="div"
                pos="absolute"
                right={nextArrRightPos || '-1.2rem'}
                top={"43%"}
                zIndex="10"
                display={{ base: 'block', md: 'block', lg: 'block' }}
            >
                <Box
                    cursor="pointer"
                    bgColor="#FFFFFF"
                    borderRadius="50%"
                    w={{base:'36px', md:'46px'}}
                    h={{base:'36px', md:'46px'}}
                    bgPos="center"
                    bgRepeat="no-repeat"
                    color="transparent"
                    bgImage={`url(https://static.sadhguru.org/d/46272/1752053543-karmasliderrightarrow.svg)`}
                    bgSize={{ base: '7px', sm: '7px', md: '10px', lg: '10px' }}
                    border={'2px solid #B7870C'}
                    onClick={onClick}
                    _hover={{
                        background: '#030040',
                        border: '2.56px solid #B7870C',
                        bgImage: 'url(https://static.sadhguru.org/d/46272/1755495244-karmasliderleftarrowhovericon.svg)',
                        transform: 'rotate(180deg)',
                        bgPos: "center",
                        bgRepeat: "no-repeat"
                    }}
                />
            </Box>)
        }
    };

    const PrevArrow = ({ onClick }) => {
        if (currentSlide/1 !== 0) {
        return (
            <Box
                as="div"
                pos="absolute"
                left={prevArrRightPos || "-1.2rem"}
                top={"43%"}
                // transform="translateY(-50%)"
                zIndex="10"
                display={{ base: 'block', md: 'block', lg: 'block' }}
            >
                <Box
                    cursor="pointer"
                    bgColor="#fff"
                    borderRadius="50%"
                    w={{base:'36px', md:'46px'}}
                    h={{base:'36px', md:'46px'}}
                    bgPos="center"
                    bgRepeat="no-repeat"
                    color="transparent"
                    transform={'rotate(180deg)'}
                    bgImage={`url(https://static.sadhguru.org/d/46272/1752053543-karmasliderrightarrow.svg)`}
                    bgSize={{ base: '7px', sm: '7px', md: '10px', lg: '10px' }}
                    // boxShadow="rgba(0, 0, 0, 0.3) 0 0 15px 0"
                    border={'2px solid #B7870C'}
                    onClick={onClick}
                    _hover={{
                        background: '#030040',
                        border: '2.56px solid #B7870C',
                        bgImage: 'url(https://static.sadhguru.org/d/46272/1755495244-karmasliderleftarrowhovericon.svg)',
                        transform: 'rotate(0deg)',
                        bgPos: "center",
                        bgRepeat: "no-repeat"
                    }}
                />
            </Box>
        );
        }
    };


    const slider_settings = {
        speed: 100,
        // paging: false,
        dots: false,
        infinite: false,
        centerMode: false,
        autoplay: false,
        lazyLoad: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerPadding: '0',
        nextArrow: <NextArrow />,
        prevArrow: <PrevArrow />,
        beforeChange: (prev, current) => setCurrentSlide(current),
        responsive: [
            {
                breakpoint: 1170,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    initialSlide: 1,
                },
            },
            {
                breakpoint: 834,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    initialSlide: 1,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    initialSlide: 1,
                },
            },
        ],
        appendDots: dots => (
            <Flex height="40px" position="relative">
                <Flex
                    marginRight="auto"
                    marginLeft="auto"
                    width="178px"
                    mt="20px"
                    justifyContent="space-between"
                >
                    {dots.map(dot => {
                        const button = dot.props.children;

                        return (
                            <button
                                key={dot.key}
                                style={{
                                    display: 'flex', // Ensure the button content aligns properly
                                    justifyContent: 'center', // Center the content horizontally
                                    alignItems: 'center', // Center the content vertically
                                    width: '16px',
                                    height: '16px',
                                    border: 'none', // Remove default browser border styles
                                    padding: '0', // Ensure no extra padding
                                    margin: '0', // Avoid unwanted margins
                                    borderRadius: '50%',
                                    boxSizing: 'border-box', // Ensure padding and borders are included in dimensions
                                    backgroundColor:
                                        currentSlide.toString() === dot.key ? '#000641' : '#DDDDDD',
                                    cursor: 'pointer',
                                }}
                                onClick={e => {
                                    button.props.onClick(e);
                                    setCurrentSlide(dot.key);
                                }}
                            >
                                <SliderDots
                                    color={currentSlide.toString() === dot.key ? '#000641' : '#DDDDDD'}
                                    style={{
                                        width: '100%',
                                        height: '100%',
                                    }}
                                />
                            </button>
                        );
                    })}
                </Flex>
            </Flex>
        ),
        customPaging: i => (
            <div
                style={{
                    marginTop: '40px',
                    width: '8px',
                    height: '8px',
                    border: 'solid #DDDDDD',
                    borderRadius: '50%',
                    cursor: 'pointer',
                    backgroundColor: '#DDDDDD',
                }}
            ></div>
        ),
    };


    return (
            <Box
                mx={{ base: '20px', md: '20px', lg: "0px" }} mt={{ base: '0px', md: '0px' }}
                // overflow={'hidden'}
                // height={{base: '164px', md: '164px', lg: '662px'}}
                position={'relative'}
            >
                <Box p="0px" id={`slider-gallery-${unqSliderId}`} w="100%" className="image-gallery">
                    <Slider key={sliderKey} {...slider_settings}>
                        {sectionContent?.images?.map((item, index) => {
                            return (
                                <Box key={nanoid()} outline="none" textAlign="center" mx="auto">
                                    <Box
                                        // m={{ base: '5px', md: '0', lg: '0' }}
                                        // transform={{ base: 'translateX(0px)', md: 'translateX(-8rem)', xl: 'translateX(-130px)' }}
                                        // height={{base:"270px", md:"365px", xl:"565px"}}
                                        // maxH={'390px'}
                                        overflow="hidden"
                                        // cursor="pointer"
                                        // transition="all 0s linear"
                                        display="flex"
                                        justifyContent="center"
                                        alignItems="center"
                                        //   margin={'0 20rem 0 0rem'}
                                        width={width}
                                        height={height}
                                    // bg={'red'}
                                    >
                                        <Image
                                            width={width}
                                            height={height}
                                            transition={{ base: 'none', md: 'none', lg: "all 0.5s ease" }}
                                            src={modifyDatoImgUrlToStatic(item.url)}
                                            alt={item.alt}
                                            title={item.title}
                                            objectFit='contain'
                                        />
                                    </Box>
                                </Box>
                            )
                        })}
                    </Slider>
                    
                    {unqSliderId ?
                    <style global jsx>{`
                        #slider-gallery-${unqSliderId} .slick-slider {
                        width: ${width.xl} !important;
                        height: ${height.xl} !important;
                        }
            
                      /* Style for the active dot */
                       #slider-gallery-${unqSliderId} .slick-slide.slick-center.slick-current {
                        width: ${width.xl} !important;
                        height: ${height.xl} !important;
                        }
            
                        #slider-gallery-${unqSliderId} .slick-slide.slick-center.slick-current * {
                        width: ${width.xl} !important;
                        height: ${height.xl} !important;
                        }
            
                      @media (max-width: 1024px) {
                        #slider-gallery-${unqSliderId} .slick-slider {
                          width: ${width.lg} !important;
                          height: ${height.lg} !important;
                        }
                        #slider-gallery-${unqSliderId} .slick-slide.slick-center.slick-current  {
                          width: ${width.lg} !important;
                          height: ${height.lg} !important;
                        }
                        #slider-gallery-${unqSliderId} .slick-slide.slick-center.slick-current * {
                          width: ${width.lg} !important;
                          height: ${height.lg} !important;
                        }
                      }
            
                      @media (max-width: 820px) {
                        #slider-gallery-${unqSliderId} .slick-slider {
                          width: ${width.md} !important;
                          height: ${height.md} !important;
                        }
                        #slider-gallery-${unqSliderId} .slick-slide.slick-center.slick-current  {
                          width: ${width.md} !important;
                          height: ${height.md} !important;
                        }
                        #slider-gallery-${unqSliderId} .slick-slide.slick-center.slick-current * {
                          width: ${width.md} !important;
                          height: ${height.md} !important;
                        }
                      }
            
                      @media (max-width: 480px) {
                        #slider-gallery-${unqSliderId} .slick-slider {
                          width: ${width.base} !important;
                          height: ${height.base} !important;
                        }
                        #slider-gallery-${unqSliderId} .slick-slide.slick-center.slick-current  {
                          width: ${width.base} !important;
                          height: ${height.base} !important;
                        }
                        #slider-gallery-${unqSliderId} .slick-slide.slick-center.slick-current * {
                          width: ${width.base} !important;
                          height: ${height.base} !important;
                        }
                      }
                    `}</style>
                    : null}
                    
                </Box>
            </Box>
    );
};

export default KarmaSliderComponent;